import { useEffect, useRef } from 'react'

const APPLE_SDK_URL = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'
const APPLE_CLIENT_ID = import.meta.env.VITE_APPLE_CLIENT_ID || 'com.quebon.tv.oauth'

interface AppleLoginButtonProps {
  onToken: (token: string, code: string) => void
}

export function AppleLoginButton({ onToken }: AppleLoginButtonProps) {
  const sdkLoadedRef = useRef(false)

  useEffect(() => {
    if (sdkLoadedRef.current) return

    const script = document.createElement('script')
    script.src = APPLE_SDK_URL
    script.onload = () => {
      sdkLoadedRef.current = true
      window.AppleID?.auth.init({
        clientId: APPLE_CLIENT_ID,
        scope: 'name email',
        redirectURI: `${window.location.origin}/auth/apple`,
        usePopup: true,
      })
    }
    document.head.appendChild(script)
  }, [])

  const handleClick = async () => {
    if (!window.AppleID?.auth) return

    try {
      const res = await window.AppleID.auth.signIn()
      const token = res.authorization.id_token
      const code = res.authorization.code

      if (res?.user?.name) {
        const { firstName, lastName } = res.user.name
        localStorage.setItem('appleSignInName', `${firstName}${lastName}`)
      }

      onToken(token, code)
    } catch (err) {
      console.error('Apple login failed:', err)
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className="w-full flex items-center justify-center gap-2 rounded-lg border border-gray-300 bg-black px-4 py-3 text-white font-medium hover:bg-gray-900 transition-colors"
    >
      Apple 로그인
    </button>
  )
}

declare global {
  interface Window {
    AppleID: {
      auth: {
        init: (config: {
          clientId: string
          scope: string
          redirectURI: string
          usePopup: boolean
        }) => void
        signIn: () => Promise<{
          authorization: { id_token: string; code: string }
          user?: { name?: { firstName: string; lastName: string }; email?: string }
        }>
      }
    }
  }
}
